import { matchRouteWithWildcards } from "@packages/sdk";

export const getScreenName = (
  pathname: string,
  options: { pathToScreenNameMap: Record<string, string> },
) => {
  const pathToScreenNameMap = options.pathToScreenNameMap ?? {};

  return (
    Object.entries(pathToScreenNameMap).find(([pattern]) =>
      matchRouteWithWildcards(pattern, pathname),
    )?.[1] ?? pathname
  );
};
